import { createAction, props } from '@ngrx/store';
import { News } from '../../models';

export const LoadFeaturedNews = createAction('[News] Load Featured News items');
export const LoadFeaturedNewsSuccess = createAction('[News] Load Featured News items Success', props<{ news: News[] }>());
export const LoadFeaturedNewsFail = createAction('[News] Load Featured News items Fail', props<{ error: any }>());
